import { useEffect, useState } from 'react'
import { fetchRecentDigestReplies, fetchRecentDigests } from '@/services/hubDigests'

export default function HubMessengerPage() {
  const [items, setItems] = useState([])
  const [replies, setReplies] = useState([])
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      const [{ data: digestData, error: digestErr }, { data: replyData, error: replyErr }] =
        await Promise.all([fetchRecentDigests(30), fetchRecentDigestReplies(30)])
      if (cancelled) return
      if (digestErr) {
        setError(digestErr.message || String(digestErr))
        setItems([])
        setReplies([])
        return
      }
      setError('')
      setItems(digestData)
      setReplies(replyErr ? [] : replyData || [])
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-lg font-semibold tracking-tight">Messenger</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Digests live in <code className="font-mono text-xs">hub_digests</code> (<code className="font-mono text-xs">content_md</code>,{' '}
          <code className="font-mono text-xs">ai_evaluation</code>). A scheduled Worker can insert rows and notify Telegram — see{' '}
          <code className="font-mono text-xs">repo_hub/MESSENGER_SETUP.md</code>. Telegram replies are stored in{' '}
          <code className="font-mono text-xs">hub_digest_replies</code> when the webhook is configured.
        </p>
      </div>

      {replies.length > 0 ? (
        <div className="mb-8">
          <h2 className="mb-2 text-sm font-medium text-foreground">Telegram replies</h2>
          <ul className="space-y-2">
            {replies.map((r) => (
              <li key={r.id} className="rounded-md border border-border bg-muted/20 px-3 py-2 text-sm">
                <span className="font-mono text-xs text-muted-foreground">
                  {r.created_at ? new Date(r.created_at).toLocaleString() : ''}
                </span>{' '}
                <span className="font-mono text-xs text-foreground">{r.item_id}</span>
                <p className="mt-1 whitespace-pre-wrap text-foreground">{r.reply_text}</p>
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      {error ? (
        <p className="text-sm text-red-400">{error}</p>
      ) : !items.length ? (
        <div className="rounded-lg border border-dashed border-border p-8 text-center text-sm text-muted-foreground">
          No digests yet.
        </div>
      ) : (
        <ul className="space-y-4">
          {items.map((d) => (
            <li key={d.id} className="rounded-lg border border-border bg-card p-4">
              <p className="text-xs font-mono text-muted-foreground">
                {d.created_at ? new Date(d.created_at).toLocaleString() : ''}
              </p>
              {d.content_md ? (
                <pre className="mt-3 whitespace-pre-wrap font-sans text-sm text-foreground">{d.content_md}</pre>
              ) : null}
              {d.ai_evaluation && Object.keys(d.ai_evaluation).length > 0 ? (
                <pre className="mt-3 overflow-x-auto rounded-md border border-border bg-muted/30 p-3 font-mono text-[11px] text-muted-foreground">
                  {JSON.stringify(d.ai_evaluation, null, 2)}
                </pre>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
